// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-bg: #ffffff;
  --color-text: #0b1f14;
  --color-muted: #44614f;
  --color-primary: #16a34a; /* green-600 */
  --color-primary-500: #22c55e;
  --color-primary-700: #15803d;
  --color-border: #e5e7eb;
}

html, body, #root {
  height: 100%;
}

body {
  margin: 0;
  background: var(--color-bg);
  color: var(--color-text);
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
}

a {
  color: var(--color-primary-700);
}

/* Utility */
.container {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 16px;
}

/* Page background tints except home route */
.page-tint {
  background: #f4fbf6;
  min-height: calc(100vh - 64px);
}

/* Mobile: hide back text, keep arrow only */
@media (max-width: 430px) {
  .back-text { display: none; }
}

`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB,EAAE,cAAc;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,gHAAgH;AAClH;;AAEA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,4CAA4C;AAC5C;EACE,aAAa,aAAa,EAAE;AAC9B","sourcesContent":[":root {\n  --color-bg: #ffffff;\n  --color-text: #0b1f14;\n  --color-muted: #44614f;\n  --color-primary: #16a34a; /* green-600 */\n  --color-primary-500: #22c55e;\n  --color-primary-700: #15803d;\n  --color-border: #e5e7eb;\n}\n\nhtml, body, #root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  background: var(--color-bg);\n  color: var(--color-text);\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n}\n\na {\n  color: var(--color-primary-700);\n}\n\n/* Utility */\n.container {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n/* Page background tints except home route */\n.page-tint {\n  background: #f4fbf6;\n  min-height: calc(100vh - 64px);\n}\n\n/* Mobile: hide back text, keep arrow only */\n@media (max-width: 430px) {\n  .back-text { display: none; }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
